import './src/utils/globals.css'
